export const KIT_SHIPPING_MINOR = 3750;

export function lineAmount(item) {
  const amount = Number(item?.amountMinor) || 0;
  if (item?.offerId) return amount;
  return amount * (Number(item?.quantity) || 0);
}

export function cartFreightMinor(items) {
  const kits = (items || []).filter((item) => item?.offerId);
  if (!kits.length) return 0;
  return kits.some((item) => item.freeShipping !== true) ? KIT_SHIPPING_MINOR : 0;
}

function kitsAtStep(kits, current, direction) {
  const step = direction < 0 ? -1 : 1;
  const candidates = (kits || []).filter((kit) =>
    step > 0 ? kit.quantity > current.quantity : kit.quantity < current.quantity
  );
  if (!candidates.length) return [];
  const quantity = step > 0
    ? Math.min(...candidates.map((kit) => kit.quantity))
    : Math.max(...candidates.map((kit) => kit.quantity));
  return candidates.filter((kit) => kit.quantity === quantity);
}

export function nextKit(kits, currentId, direction) {
  const current = (kits || []).find((kit) => kit.id === currentId);
  if (!current) return null;
  const matches = kitsAtStep(kits, current, direction);
  return matches.length === 1 ? matches[0] : null;
}

export function ambiguousKitStep(kits, currentId, direction) {
  const current = (kits || []).find((kit) => kit.id === currentId);
  if (!current) return false;
  return kitsAtStep(kits, current, direction).length > 1;
}
